import style from "./RadioButton.module.scss";
import { Fragment, useEffect, useState} from "react";


interface IRadioButtonProps {
    data: { id: string, name:string, number?: number }[],
    name:string,
    width?: number,
    defaultValue?: string,
    isPTM?: boolean
}

export default function RadioButton({
    data,
    name,
    width,
    defaultValue,
    isPTM
}: IRadioButtonProps){
    const [value, setValue] = useState<string>(defaultValue ?? '')

    useEffect(() => {
        setValue(defaultValue ?? '')
    }, [defaultValue])

    return(
        <div
            style={{
            width: width ? `${width}px` : "auto",
            }}
            className={isPTM ? style['ptm-radio'] : style['radio']}
        >
            {data.map((d) => (
                    <Fragment key={name + d.id}>
                        <input type="radio" className="btn-check" name={name} id={name +d.id} value={d.id}
                               autoComplete="off"
                               onChange={e=> {
                                   setValue(e.target.value)
                               }}
                               checked={(d.id === value)} />
                        <label className={`btn--blank ${isPTM ? style['ptm-radio-label'] : style['radio-label']}`}
                               htmlFor={name + d.id}>{d.name}</label>
                    </Fragment>
                )
            )}
        </div>
    );
}